export enum ActionTypes {
  GET_INSIGHTS_PROPOSALS_REQUEST = "@@insight_proposals/GET_INSIGHTS_PROPOSALS_REQUEST",
  GET_INSIGHTS_PROPOSALS_SUCCESS = "@@insight_proposals/GET_INSIGHTS_PROPOSALS_SUCCESS",
  GET_INSIGHTS_PROPOSALS_FAILURE = "@@insight_proposals/GET_INSIGHTS_PROPOSALS_FAILURE",

  CREATE_INSIGHTS_PROPOSALS_REQUEST = "@@insight_proposals/CREATE_INSIGHTS_PROPOSALS_REQUEST",
  CREATE_INSIGHTS_PROPOSALS_SUCCESS = "@@insight_proposals/CREATE_INSIGHTS_PROPOSALS_SUCCESS",
  CREATE_INSIGHTS_PROPOSALS_FAILURE = "@@insight_proposals/CREATE_INSIGHTS_PROPOSALS_FAILURE",
}
